import React from "react";
import styles from "./DateSeparator.module.css";
import {formatDateTime} from "../../../../../../../utils/dateTimeUtil";

interface DateSeparatorProps {
    timestamp: string;
}

export const DateSeparator: React.FC<DateSeparatorProps> = ({timestamp}) => {

    const {date} = formatDateTime(timestamp)
    return (
        <div className={styles.wrapper}>
            <div className={styles.line}/>
            <span className={styles.date}>{date}</span>
            <div className={styles.line}/>
        </div>
    )
}
